export const focusedWithinComponent = (
  id: string,
  eventOrElement: Event | Element,
) => {
  const componentElement = document.getElementById(id);
  const comparedElement =
    eventOrElement instanceof Event
      ? (eventOrElement.target as Node)
      : eventOrElement;
  return componentElement?.contains(comparedElement);
};
